import { COLLECTIONS } from '../components/Firebase/firebase';
import * as firebase from 'firebase';

class GeolocationService {
    constructor() {
        this.geo_options = {
					enableHighAccuracy: true, 
					maximumAge        : 30000, 
					timeout           : 27000
				};
    }

    watchPosition  = (profileId, isFaculty) => {
			let previousLatitude = 0, previousLongitude = 0, currentLatitude = 0, currentLongitude = 0, needUpdate;
			if(navigator.geolocation) {
				this.watchId = navigator.geolocation.watchPosition(position => {
					currentLatitude =  position.coords.latitude;
					currentLongitude = position.coords.longitude;
					needUpdate = true;
					if(previousLatitude === currentLatitude && previousLongitude === currentLongitude)
						needUpdate = false;
					if(needUpdate) {
						if(isFaculty) {
							firebase.firestore().doc(`${COLLECTIONS.faculties}/${profileId}`).update({
								latitude: currentLatitude,
								longitude: currentLongitude
							});
						} else {
									firebase.firestore().doc(`${COLLECTIONS.students}/${profileId}`).update({
								latitude: currentLatitude,
								longitude: currentLongitude
							});
						}
					}
					previousLatitude = currentLatitude;
					previousLongitude = currentLongitude;
				}, err => {
					console.log('error: ', err);
				}, this.geo_options) 
			} else {
				console.log("This browser doesn't support Geolocation");
			}
    }

    getCurrentLocation = () => {
			return new Promise((resolve, reject) => {
				if(navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(position => {
						resolve(position);
					}, err => {
						console.log('error: ', err);
						reject(err)
					}, this.geo_options)
				} else {
					console.log("This browser doesn't support Geolocation");
					reject();
				}
			})
    }
    
    cancelWatchLocation = () => {
		if(this.watchId)
			navigator.geolocation.clearWatch(this.watchId);
	}
		
	getLocationPermission = () => {
		console.log('permission',localStorage.getItem('locationEnabled'));
		return (localStorage.getItem('locationEnabled') === "TRUE");
	}

	setLocationEnabled = () => {
		localStorage.setItem('locationEnabled', "TRUE");	
	}

	setLocationDisabled = () => {
		localStorage.setItem('locationEnabled', "FALSE");	
	}
};

export default GeolocationService;